import styled, { css } from 'styled-components';

interface ContainerProps {
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  background: #fff;
  padding: 10px 0;
  width: 100%;
  color: #666360;

  label {
    color: #333;
    font-size: 1rem;
    font-weight: 500;
    margin-left: 5px;
  }

  input {
    width: 25px;
    height: 20px;
  }

  ${props =>
    props.isErrored &&
    css`
      color: #c53030;
    `}
`;
